import { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function StreakFreezeToast() {
  const [event, setEvent] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setEvent(e.detail);
      setTimeout(() => setEvent(null), 7000);
    };
    window.addEventListener("streakFreeze:used", handler);
    return () => window.removeEventListener("streakFreeze:used", handler);
  }, []);

  if (!event) return null;

  return (
    <div className="fixed top-4 right-4 z-[200] max-w-sm w-[calc(100vw-2rem)] sm:w-80 pointer-events-auto">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-sky to-sky-dark text-white p-4 shadow-2xl border-2 border-white/30 animate-fade-in">
        <button onClick={() => setEvent(null)} className="absolute top-2 right-2 p-1 rounded-full hover:bg-white/20"><X className="w-3.5 h-3.5" /></button>
        <div className="flex items-start gap-3">
          <div className="text-3xl animate-bounce">🛡️</div>
          <div>
            <p className="text-[10px] font-black uppercase tracking-wider text-sky-light mb-0.5">Streak Saved!</p>
            <h4 className="font-black text-base leading-tight">Streak Freeze used</h4>
            <p className="text-xs text-white/90 mt-0.5 leading-snug">
              You missed yesterday — but your {event.streak}-day streak is safe. {event.remaining} freeze{event.remaining !== 1 ? "s" : ""} remaining.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
